<template>
  <div id="app" class="main-content dashboard">
    <div class="row">
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/anchor/suppliers">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount">
                {{ getSuppliers }}
              </span>
              <span class="title">
                {{ $t("suppliers.title") }}
              </span>
            </div>
            <div class="icon">
              <contact-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>

      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/anchor/invoices">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount">
                {{ getInvoices }}
              </span>
              <span class="title">
                {{ $t("dashboard.cards.invoices") }}
              </span>
            </div>
            <div class="icon">
              <invoice-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/anchor/purchase-orders">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount">
                {{ getPurchaseOrders }}
              </span>
              <span class="title">
                {{ $t("dashboard.cards.purchase_orders") }}
              </span>
            </div>
            <div class="icon">
              <estimate-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 mt-2">
        <div class="card dashboard-card">
          <div class="graph-body">
            <div class="card-body col-md-12 col-lg-12 col-xl-10">
              <div class="card-header">
                <h6>
                  <i class="fa fa-line-chart text-primary"></i>
                  {{ $t("dashboard.cards.invoices") }}
                </h6>
                <div>
                  <base-select
                    v-model="selectedSupplier"
                    :options="suppliers"
                    :searchable="true"
                    :show-labels="false"
                    :allow-empty="true"
                    :tabindex="8"
                    :placeholder="$t('dashboard.select_supplier')"
                    label="name"
                    track-by="id"
                  />
                </div>
              </div>
              <bar-chart
                v-if="isLoaded"
                :label="'Invoices'"
                :labels="labels"
                :values="invoiceGroupCount"
                :backgroundColor="bgColors"
                :borderColor="bgColors"
                :hoverBackgroundColor="bgColors"
                :hoverBorderColor="bgColors"
                :updateChart="updateChart"
              />
            </div>
            <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
              <div class="stats">
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.received") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#00FFFF;">
                    <div v-html="invoiceGroupCount[0]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.authorized") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#008080;">
                    <div v-html="invoiceGroupCount[1]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.approved") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#2080B9;">
                    <div v-html="invoiceGroupCount[2]"></div>
                  </span>
                </div>

                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.pending") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#334CFF;">
                    <div v-html="invoiceGroupCount[3]"></div>
                  </span>
                </div>

                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.offered") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#E333FF;">
                    <div v-html="invoiceGroupCount[4]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.financed") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#33FF71;">
                    <div v-html="invoiceGroupCount[5]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.prepaid") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#F9FF33;">
                    <div v-html="invoiceGroupCount[6]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.settlement") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#FFB233;">
                    <div v-html="invoiceGroupCount[7]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.rejected") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total" style="color:#FF3F33;">
                    <div v-html="invoiceGroupCount[8]"></div>
                  </span>
                </div>
                <div class="description">
                  <span class="title">
                    {{ $t("dashboard.invoice_chart.total_invoice") }}
                  </span>
                  <br />
                  <span v-if="isLoaded" class="total">
                    <div v-html="totalinvoiceGroup"></div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import PieChart from "../../components/chartjs/PieChart";
import BarChart from "../../components/chartjs/BarChart";
import DollarIcon from "../../components/icon/DollarIcon";
import ContactIcon from "../../components/icon/ContactIcon";
import InvoiceIcon from "../../components/icon/InvoiceIcon";
import EstimateIcon from "../../components/icon/EstimateIcon";

export default {
  components: {
    PieChart,
    BarChart,
    DollarIcon,
    ContactIcon,
    InvoiceIcon,
    EstimateIcon
  },
  data() {
    return {
      hoverBgColors: [],
      bgColors: [
        "#00FFFF",
        "#008080",
        "#2080B9",
        "#334CFF",
        "#E333FF",
        "#33FF71",
        "#F9FF33",
        "#FFB233",
        "#FF3F33"
      ],
      values: [20, 20, 5, 9, 7],
      labels: [
        "Received",
        "Authorized",
        "Approved",
        "Pending",
        "Offered",
        "Financed",
        "Prepaid",
        "Settlement",
        "Rejected"
      ],
      isLoaded: false,
      years: ["This year", "Previous year"],
      selectedYear: "This year",
      selectedSupplier: null,
      updateChart: false
    };
  },
  computed: {
    ...mapGetters("anchorDashboard", [
      "getContacts",
      "getInvoices",
      "getSuppliers",
      "getPurchaseOrders",
      "invoiceGroupCount"
    ]),
    ...mapGetters("supplier", ["suppliers"]),
    totalinvoiceGroup() {
      return this.invoiceGroupCount.reduce((acc, item) => acc + item, 0);
    }
  },
  watch: {
    selectedSupplier(val) {
      if (val != null) {
        this.updateChart = false;
        let params = { user_id: val.id };
        this.loadData(params);
      } else {
        this.loadData();
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("anchorDashboard", ["loadData"]),

    async loadData(params) {
      let res = await this.$store.dispatch("anchorDashboard/loadData", params);
      if (res.data.user == true) {
        this.updateChart = true;
      }
      this.isLoaded = true;
    }
  }
};
</script>
